import React, {forwardRef} from 'react';
import classNames from 'classnames';

import {Handle, Remove} from '../Item';

require('./Container.scss');

export interface Props {
  children: React.ReactNode;
  columns?: number;
  label?: string;
  style?: React.CSSProperties;
  listStyle?: React.CSSProperties;
  horizontal?: boolean;
  hover?: boolean;
  handleProps?: React.HTMLAttributes<any>;
  showHandle?: boolean;
  scrollable?: boolean;
  shadow?: boolean;
  placeholder?: boolean;
  unstyled?: boolean;
  onClick?(): void;
  onRemove?(): void;
}

export const Container = forwardRef<HTMLDivElement, Props>(
  (
    {
      children,
      columns = 1,
      handleProps,
      showHandle,
      horizontal,
      hover,
      onClick,
      onRemove,
      label,
      placeholder,
      style,
      listStyle,
      scrollable,
      shadow,
      unstyled,
      ...props
    }: Props,
    ref
  ) => {

    // FIXME ( use the Component instead of a hard coded div below.)
    const Component = onClick ? 'button' : 'div';

    return (
      <div
        {...props}
        ref={ref}
        style={
          {
            ...style,
            '--columns': columns,
          } as React.CSSProperties
        }
        className={classNames(
          'dnd-container',
          unstyled && 'dnd-container-unstyled',
          horizontal && 'dnd-container-horizontal',
          hover && 'dnd-container-hover',
          placeholder && 'dnd-container-placeholder',
          scrollable && 'dnd-container-scrollable',
          shadow && 'dnd-container-shadow'
        )}
        onClick={onClick}
        tabIndex={onClick ? 0 : undefined}
      >
        {label ? (
          <div className={'dnd-container-header'}>
            {label}
            <div className={'dnd-container-actions'}>
              {onRemove ? <Remove onClick={onRemove} /> : undefined}
              {showHandle ? <Handle {...handleProps} /> : undefined}
            </div>
          </div>
        ) : null}
        {placeholder ? children : <ul style={listStyle}>{children}</ul>}
      </div>
    );
  }
);
